// Display helpers for the keyword-cluster screens.
//
// The one rule that matters here: `null` and `0` are NOT the same thing.
// services/blog/clusters/clusterMetrics.js goes out of its way to keep
// "never measured" (null) distinct from "measured as zero" (0), because
// collapsing them silently promotes dead clusters as opportunities. The UI
// must not undo that — so a missing metric renders as an em dash, never "0".

/** Thousands-separated integer; non-numbers fall back to the em dash. */
export function formatNumber(value) {
  return typeof value === "number" && Number.isFinite(value)
    ? value.toLocaleString("en-US")
    : "—";
}

/**
 * A measured metric (volume, KD, position).
 * `null`/`undefined` → "—" (never measured); `0` → "0" (measured as zero).
 */
export function formatMetric(value) {
  if (value === null || value === undefined) return "—";
  if (typeof value !== "number" || !Number.isFinite(value)) return "—";
  return Number.isInteger(value) ? String(value) : value.toFixed(1);
}

/** Cost-per-click, which is a currency and so keeps two decimals. */
export function formatCpc(value) {
  if (value === null || value === undefined) return "—";
  if (typeof value !== "number" || !Number.isFinite(value)) return "—";
  return `$${value.toFixed(2)}`;
}
